import React, {useEffect} from "react";
import {
    Switch,
    Route,
    Redirect
} from "react-router-dom";
import {IndexPage} from "~/apps/packages/auto-visits/components/IndexPage";
import {DetailPage} from "~/apps/packages/auto-visits/components/DetailPage";
import {AccessRequired} from "~/apps/core/ui/AccessRequired";
import {EditPage} from "~/apps/packages/auto-visits/components/EditPage";
import {CreatePage} from "~/apps/packages/auto-visits/components/CreatePage";
import {BrowserRouter} from "~/apps/core/BrowserRouter";
import {useApolloClient} from "@apollo/client";
import {ServiceInterview} from "~/customers-experience/ServiceInterview";


export const APP_VERSION = "1.0.0";
export const APP_NAME = "auto-visits";


const AutoVisitsApp = () => {
    const client = useApolloClient();

    // Invalidate apollo cache when leave service
    useEffect(() => () => {
        client.cache.evict({id: "ROOT_QUERY", fieldName: "autovisits"});
        client.cache.evict({id: "ROOT_QUERY", fieldName: "autoVisit"});
        client.cache.evict({id: "ROOT_QUERY", fieldName: "cargos"});
        client.cache.evict({id: "ROOT_QUERY", fieldName: "services"});
        client.cache.evict({id: "ROOT_QUERY", fieldName: "timeSlots"});
        client.cache.evict({id: "ROOT_QUERY", fieldName: "vehicles"});
        client.cache.evict({id: "ROOT_QUERY", fieldName: "drivers"});
        client.cache.evict({id: "ROOT_QUERY", fieldName: "checkPoints"});
    }, []);

    return (
        <AccessRequired title="Автовизиты">
            <BrowserRouter basename="/apps/auto-visits">
                <ServiceInterview serviceID={APP_NAME} serviceVersion={APP_VERSION}>
                    <Switch>
                        <Route path="/new">
                            <CreatePage/>
                        </Route>
                        <Route path="/:id" exact={true}>
                            <DetailPage/>
                        </Route>
                        <Route path="/:id/edit" exact={true}>
                            <EditPage/>
                        </Route>
                        <Route path="/" exact={true}>
                            <IndexPage/>
                        </Route>
                        <Route path="*">
                            <Redirect to="/"/>
                        </Route>
                    </Switch>
                </ServiceInterview>
            </BrowserRouter>
        </AccessRequired>
    );
}


export default AutoVisitsApp;